import './index.scss'
import NavigationSidebarItem from './NavigationSidebarItem'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { isNavigationAllowed, propertyNavRoutes } from './NavigationHelper'

const NavigationSidebar = function (
  {
    permissions,
    property,
    onNavigate
  }
) {
  const { t } = useTranslation()
  if (!property || !permissions) return null
  return <div id="property-nav-sidebar">
    <div style={{ marginTop: '69px', marginBottom: '32px' }}>
      <NavigationSidebarItem
        title={t('MY_PROPERTIES')}
        route={`/properties-list`}
        boldItem={true}
        onNavigate={onNavigate}
      />
    </div>
    <div className="nav-sidebar-header">TOOLS</div>
    <NavigationSidebarItem title={t('MANAGE_PROPERTY')} onNavigate={onNavigate}>
      {
        isNavigationAllowed(propertyNavRoutes.editProperty, permissions) && <NavigationSidebarItem
          title={t('EDIT_PROPERTY')}
          route={`/property/${property.giataId}/edit`}
          onNavigate={onNavigate}
        />
      }
      <NavigationSidebarItem
        title={t('EDIT_ROOMS')}
        route={`/property/${property.giataId}/edit-rooms`}
        onNavigate={onNavigate}
      />
      <NavigationSidebarItem
        title={t('IMAGES')}
        route={`/property/${property.giataId}/images`}
        onNavigate={onNavigate}
      />
    </NavigationSidebarItem>
    <NavigationSidebarItem title="Share Content" onNavigate={onNavigate}>
      {
        isNavigationAllowed(propertyNavRoutes.ocl, permissions) && <NavigationSidebarItem
          title={t('OPEN_CONTENT_LINK')}
          route={`/property/${property.giataId}/open-content-link`}
          onNavigate={onNavigate}
        />
      }
      <NavigationSidebarItem
        title={t('DISTRIBUTION_CHANNEL_LIST')}
        route={`/property/${property.giataId}/channel-list`}
        onNavigate={onNavigate}
      />
    </NavigationSidebarItem>
    <NavigationSidebarItem title={t('ANALYTICS_AND_INSIGHTS')} onNavigate={onNavigate}>
      {
        isNavigationAllowed(propertyNavRoutes.tourOperators, permissions) && <NavigationSidebarItem
          title={t('LABEL_TOUR_OPERATORS')}
          route={`/property/${property.giataId}/tour-operators`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.distribution, permissions) && <NavigationSidebarItem
          title={t('SALES_CHANNELS')}
          route={`/property/${property.giataId}/sales-channels`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.dashboard, permissions) && <NavigationSidebarItem
          title={t('TABLE_HEAD_DASHBOARD')}
          route={`/property/${property.giataId}/dashboard`}
          onNavigate={onNavigate}
        />
      }
      {
        isNavigationAllowed(propertyNavRoutes.compare, permissions)
        && <NavigationSidebarItem
          title={t('COMPARE_HOTELS')}
          route={`/property/${property.giataId}/compare-hotels`}
          onNavigate={onNavigate}
        />
      }
    </NavigationSidebarItem>
  </div>
}

NavigationSidebar.propTypes = {
  permissions: PropTypes.object,
  property: PropTypes.object,
  onNavigate: PropTypes.func
}

export default NavigationSidebar
